import { Field } from "formik"
import React, { Fragment } from "react"
import PropTypes from "prop-types"
import { Divider, Form, Header } from "semantic-ui-react"

const AvailableFields = ({ availableFields, checkedFields, onCheckAllChange }) => (
	<Fragment>
		<Header as="h4">Dostępne pola</Header>
		<Form.Checkbox
			checked={checkedFields.length === availableFields.length}
			id="available-fields-check-all"
			indeterminate={
				checkedFields.length > 0 && checkedFields.length < availableFields.length
			}
			label="Zaznacz wszystkie"
			onChange={onCheckAllChange}
		/>
		<Divider />
		{availableFields.map(({ desc, id, name }) => (
			<Field key={id} name="availableFields">
				{({ field, form }) => (
					<Form.Checkbox
						checked={field.value.includes(name)}
						label={desc}
						onChange={() => {
							const nextValue = field.value.includes(name)
								? field.value.filter(fieldValue => fieldValue !== name)
								: [...field.value, name]
							form.setFieldValue(field.name, nextValue)
						}}
						value={name}
					/>
				)}
			</Field>
		))}
	</Fragment>
)

AvailableFields.propTypes = {
	availableFields: PropTypes.arrayOf(
		PropTypes.shape({ desc: PropTypes.string, id: PropTypes.number, name: PropTypes.string })
	),
	checkedFields: PropTypes.arrayOf(PropTypes.string),
	onCheckAllChange: PropTypes.func.isRequired
}

AvailableFields.defaultProps = {
	availableFields: [],
	checkedFields: []
}

export { AvailableFields }
export default AvailableFields



// WEBPACK FOOTER //
// ./src/containers/contexts/components/context-form-modal/AvailableFields.js